

let backendHost;
let socketHost;
let appLogin;
let bucketName;
const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const hostname = window && window.location && window.location.hostname;
if (hostname === 'acdev.cianlogic.com') {
  backendHost = 'https://acdevapi.cianlogic.com';
  socketHost = 'wss://acdevapi.cianlogic.com';
  appLogin = 'https://acweb.cianlogic.com/';
  bucketName = 'acdev';
} else if (hostname === 'localhost') {
  backendHost = 'https://acdevapi.cianlogic.com';
  socketHost = 'wss://acdevapi.cianlogic.com';
  appLogin = 'https://acweb.cianlogic.com/';
  bucketName = 'acdev';
} else if (hostname === 'acbackstage.cianlogic.com') {
  backendHost = 'https://acstageapi.cianlogic.com';
  socketHost = 'wss://acstageapi.cianlogic.com';
  appLogin = 'https://acstage.cianlogic.com/';
  bucketName = 'acstage';
}
else if (hostname === 'app.aryalcare.com') {
  backendHost = 'https://api.aryalcare.com';
  socketHost = 'wss://api.aryalcare.com';
  appLogin = 'https://vendor.aryalcare.com/';
  bucketName = 'acproduction';
}

export const appLoginUrl = `${appLogin}`
export const APIURL = `${backendHost}`;
export const SOCKETURL = `${socketHost}`;
export const TZ = `timeZone=${currentTimezone}`;
export const BUCKETNAME = `${bucketName}`;




